import { getDefaultMiddleware } from '@databases/utils/redux/redux';
import { configureStore } from '@reduxjs/toolkit';

import { defaultReducers, getAppStoreUtils } from './redux';
import { resolvedSelectionMiddleware } from './rovo-referenced-content/middleware';
import { type AppRootState } from './types';

export const appStore = configureStore({
  reducer: {
    ...defaultReducers,
  },
  middleware: getDefaultMiddleware([resolvedSelectionMiddleware.middleware]),
});

export type { AppRootState } from './types';
export const appStoreUtils = getAppStoreUtils<AppRootState>();
